<div class="tc-table-page-header" tc-sticky-header fxLayoutAlign="space-between center">
  <div fxFlex>
    <div class="mat-headline-6">TradeCafé · Client Shipping Log</div>
  </div>
</div>

<div class="tc-table-page-filters wht-bg-container">
  <div style="width: 322px">
    <tc-select-search placeholder="Buyer"
      [group]="filtersForm" ctrlName="buyer"
      [items]="buyers$ | async"
      bindValue="id"
      bindLabel="name"
      clearable="true"
    ></tc-select-search>
  </div>
</div>

@if (showLogsForm) {
  <div class="wht-bg-container">
    <div [ngClass]="buyerHasNoLogs ? 'no-logs' : 'no-logs-disabled'">
      <img src="assets/images/no-result.png">
      <span class="no-logs-bold">No Shipping Log Columns have been setup</span>
      <span class="no-logs-lightgray"> Please ask your Logistics Coordinator to set up this buyer for you</span>
    </div>
    <div [class.no-logs-disabled]="buyerHasNoLogs">
      <h4>Client Shipping Log Preview</h4>
      <hr>
          <tc-deals-list
            [dataSource]="dataSource"
            [totals$]="totals$"
            [columnNames]="columnNames"
            [displayColumns]="displayColumns"
            [availableColumns]="displayColumns"
            [tableIdentity]="tableIdentity"
            [isEditBlocked]="true"
            [isScrollable]="true"
          ></tc-deals-list>
    </div>
  </div>
  }



